import React, { Component } from 'react';
import { Col, Row, Button, FormControl, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { removePortfolioUser, deletePortfolio } from '../../../actions';

class DeletePortfolio extends Component {
  constructor(props) {
    super(props);

    this.state = {
      portfolioName: '',
      isValid: false
    };
  }

  onRemovePortfolio = (e) => {
    e.preventDefault();
    if (this.state.portfolioName === this.props.session.activePortfolioUser.name) {
      const { activePortfolioUser } = this.props.session;
      this.props.removePortfolioUser({
        portfolioUserId: activePortfolioUser.id,
        user_id: activePortfolioUser.user_id
      });
      this.props.closeModal();
    } 
  }

  onDeletePortfolio = (e) => {
    e.preventDefault();
    if (this.state.portfolioName === this.props.session.activePortfolioUser.name) {
      const { activePortfolioUser } = this.props.session;
      this.props.deletePortfolio({
        portfolioId: activePortfolioUser.portfolio_id
      });
      this.props.closeModal();
    } 
  }

  onInputChange = (e) => {
    this.setState({ portfolioName: e.target.value }, () => {
      if (this.state.portfolioName === this.props.session.activePortfolioUser.name) {
        this.setState({ isValid: true });
      } else {
        this.setState({ isValid: false });
      }
    });
  }

  render() {
    const { activePortfolioUser } = this.props.session;

    if (activePortfolioUser.privilege === 'owner') {
      return (
        <Row>
          <Col md={12}>
            <p>This action <b>cannot</b> be undone. You are the owner and this action will permanently
             delete the <b>{activePortfolioUser.name}</b> portfolio, along with everyone's access. Please type in the name of the portfolio to confirm:</p>
          </Col>
          <Col mdOffset={2} md={8}>
            <Form onSubmit={(e) => this.onDeletePortfolio(e)}> 
              <FormControl 
                type="text" 
                className="remove-portfolio-input"
                placeholder="Enter portfolio name" 
                value={this.state.portfolioName} 
                onChange={(e) => this.onInputChange(e)} />
              <Button   
                disabled={ this.state.isValid ? false : true }                              
                bsStyle="danger"
                className="btn-red remove-portfolio-btn"
                type="submit">
                I understand the consequences, delete this portfolio
              </Button>
            </Form>
          </Col>
        </Row>
      );
    }

    return (
      <Row>
        <Col md={12}>
          <p>This action will remove the <b>{activePortfolioUser.name}</b> portfolio. Please type in the name of the portfolio to confirm:</p>
        </Col>
        <Col mdOffset={2} md={8}>
          <Form onSubmit={(e) => this.onRemovePortfolio(e)}> 
            <FormControl 
              type="text" 
              className="remove-portfolio-input"
              placeholder="Enter portfolio name" 
              value={this.state.portfolioName} 
              onChange={(e) => this.onInputChange(e)} />
            <Button 
              disabled={ this.state.isValid ? false : true }  
              bsStyle="danger"
              className="btn-red remove-portfolio-btn"
              type="submit">
              Remove
            </Button>
          </Form>
        </Col>
      </Row>
    );
  }
}

function mapStateToProps({ session }) {
  return {
    session
  };
}

export default connect(mapStateToProps, { removePortfolioUser, deletePortfolio })(DeletePortfolio);